import { useMutation } from '@tanstack/react-query';
import { ticketsService, type TicketDraftMessage } from '@/services/ticketsService';

/** Plain request/response per turn — no SSE/streaming client needed, the
 * backend call is a single short LLM invocation, not a long agentic run. */
export function useTicketAIDraft() {
  return useMutation({
    mutationFn: (messages: TicketDraftMessage[]) => ticketsService.draftFromConversation(messages),
  });
}
